import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";

export const ReviewsIcon = ({
  width = "24",
  height = "24",
  color = "#4C545B",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.075 14.25L12 12.475L14.925 14.25L14.15 10.925L16.75 8.675L13.325 8.4L12 5.25L10.675 8.4L7.25 8.675L9.85 10.925L9.075 14.25ZM2 22V4C2 3.45 2.196 2.97933 2.588 2.588C2.98 2.19667 3.45067 2.00067 4 2H20C20.55 2 21.021 2.196 21.413 2.588C21.805 2.98 22.0007 3.45067 22 4V16C22 16.55 21.8043 17.021 21.413 17.413C21.0217 17.805 20.5507 18.0007 20 18H6L2 22ZM5.15 16H20V4H4V17.125L5.15 16Z"
          fill={color}
        />
        <defs>
          <clipPath id="clip0_7636_29181">
            <rect width={width} height={height} fill="white" />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
};
